import { useContext, useState, useEffect } from 'react';
import { DataContext } from '../../data/DataContext';
import { GetResumen } from '../../data/Help';
import { Tooltip } from '../controls/Tooltip';

const Step4 = () => {
    const { IH_CR, setIH_CR } = useContext(DataContext);
    const [detail, setDetail] = useState([] as Array<IIncendioHogarCRCoverage>);
    const [resumen, setResumen] = useState({} as IIncendioHogarCRResumen);

    useEffect(() => {
        const resumen = GetResumen(IH_CR);
        setDetail(resumen.coverageDetail);
        setResumen(resumen);
        setIH_CR({ ...IH_CR, summary: resumen });
    }, []);


    return (
        <>
            <table className='table-ih-cr-cover'>
                <thead>
                    <tr >
                        <th className='table-ih-cr-cover-hd display-flex' colSpan={2}>Sus Coberturas <Tooltip id='idCoverage' text='Protección contratada para cubrir el bien ante siniestros' title='Coberturas' /> </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        detail.map((coverage: IIncendioHogarCRCoverage) => {
                            return (
                                <>
                                    <tr>
                                        <td className='table-ih-cr-cover-txt1' colSpan={2}>{coverage.name}</td>
                                    </tr>
                                    <tr className='pt-0'>
                                        <td width='80%' className='table-ih-cr-cover-txt2 pt-0'>Suma asegurada</td>
                                        <td width='20%' className='text-right-ih-cr table-ih-cr-cover-txt1 pt-0'>{coverage.value}</td>
                                    </tr>
                                    <tr className='pt-0'>
                                        <td width='80%' className='table-ih-cr-cover-txt2 pt-0'>Prima</td>
                                        <td width='20%' className='text-right-ih-cr table-ih-cr-cover-txt1 pt-0'>{coverage.insured}</td>
                                    </tr>
                                </>
                            );
                        })
                    }
                    <tr>
                        <td ></td>
                    </tr>
                </tbody>
            </table>
            <table className='table-ih-cr-det'>
                <thead>
                    <tr className='table-ih-cr-det-hd'>
                        <th>Resumen de prima</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Prima</td>
                        <td className='text-right-ih-cr'>{resumen.bonusStr}</td>
                    </tr>
                    <tr>
                        <td>Descuento</td>
                        <td className='text-right-ih-cr'>{resumen.descStr}</td>
                    </tr>
                    <tr>
                        <td>Prima neta</td>
                        <td className='text-right-ih-cr'>{resumen.bonus2Str}</td>
                    </tr>
                    <tr>
                        <td>Impuesto</td>
                        <td className='text-right-ih-cr'>{resumen.taxStr}</td>
                    </tr>
                    <tr>
                        <td>Fraccionamiento</td>
                        <td className='text-right-ih-cr'>{resumen.financingStr}</td>
                    </tr>
                    <tr>
                        <td>Total</td>
                        <td className='text-right-ih-cr'>{resumen.totalStr}</td>
                    </tr>
                </tbody>
            </table>
            <table className='table-ih-cr-det'>
                <thead>
                    <tr className='table-ih-cr-det-hd'>
                        <th>Frecuencia de pago</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Mensual</td>
                        <td className='text-right-ih-cr'>{resumen.bonusMonthly}</td>
                    </tr>
                    <tr>
                        <td>Trimestral</td>
                        <td className='text-right-ih-cr'>{resumen.bonusQuarterly}</td>
                    </tr>
                    <tr>
                        <td>Semestre</td>
                        <td className='text-right-ih-cr'>{resumen.bonusSemester}</td>
                    </tr>
                    <tr>
                        <td>Anual</td>
                        <td className='text-right-ih-cr'>{resumen.bonusAnnual}</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}

export { Step4 };